import { render } from "./NeedHelp.vue?vue&type=template&id=6d42fe15&scoped=true"
import script from "./NeedHelp.vue?vue&type=script&lang=js"
export * from "./NeedHelp.vue?vue&type=script&lang=js"

import "./NeedHelp.vue?vue&type=style&index=0&id=6d42fe15&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d42fe15"]])

export default __exports__